export default __webpack_public_path__ + "static/media/solution_54.c9db226b.svg";